import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step2Badge", "step2Text", "step3Badge", "step3Text", "step2Button", "confirmSection"]

  // ステップ2のボタンをクリックした時
  advanceToStep3() {
    // ステップ2を完了状態に
    if (this.hasStep2BadgeTarget) {
      this.step2BadgeTarget.classList.remove('bg-primary')
      this.step2BadgeTarget.classList.add('bg-success')
      this.step2BadgeTarget.innerHTML = '<i class="bi bi-check"></i>'
    }
    if (this.hasStep2TextTarget) {
      this.step2TextTarget.classList.remove('fw-bold')
      this.step2TextTarget.classList.add('text-muted', 'text-decoration-line-through')
    }

    // ステップ2のボタンを控えめに
    if (this.hasStep2ButtonTarget) {
      this.step2ButtonTarget.classList.remove('btn-primary')
      this.step2ButtonTarget.classList.add('btn-outline-secondary')
    }

    // ステップ3を強調状態に
    if (this.hasStep3BadgeTarget) {
      this.step3BadgeTarget.classList.remove('bg-secondary')
      this.step3BadgeTarget.classList.add('bg-primary')
    }
    if (this.hasStep3TextTarget) {
      this.step3TextTarget.classList.remove('text-muted')
      this.step3TextTarget.classList.add('fw-bold')
    }

    // 確認セクションを表示
    if (this.hasConfirmSectionTarget) {
      this.confirmSectionTarget.classList.remove('d-none')
    }
  }
}